export const TENANT = process.env.REACT_APP_TENANT ? process.env.REACT_APP_TENANT : (window.location.pathname.split('/')[1] !== "app" ? window.location.pathname.split('/')[1] : "") 
export const API_URL = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? `http://127.0.0.1:8000/${TENANT}/api` : (process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/${TENANT}/api` : `${window.location.origin}/${TENANT}/api`);
export const API_URL_WITHOUT_TENANT = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? `http://127.0.0.1:8000/api` : (process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/${TENANT}/api` : `${window.location.origin}/api`);
export const BASE_URL = `${window.location.origin}/${TENANT}`
export const HTTP_TIMEOUT = 10000;
export const DEFAULT_FIELDS = ['firstname', 'lastname', 'nickname']
export const DEVICE = {
  mobile: `(min-width: 320px)`,
  tablet: `(min-width: 768px)`,
  laptop: `(min-width: 1024px)`,
  laptopL: `(min-width: 1440px)`,
  desktop: `(min-width: 2560px)`,
};
export const USER_STATUS = {
  waiting_admin_check : {
    background: "#FFFAE7",
    color: "#FFA800"
  },
  active: {
    background: "#F0FFE0",
    color: "#41790A"
  },
  suspended: {
    background: "#FFB7B7",
    color: "#C63838"
  }
}
export const EXAMS_STATUS = {
  draft : {
    background: "#F4F5F6",
    color: "#6D6F73"
  },
  ready: {
    background: "#F0FFE0",
    color: "#41790A"
  },
  deleted: {
    background: "#FFE0E0",
    color: "#A22020"
  },
  future: {
    background: "#FFF3E4",
    color: "#A45E0B"
  },
  past: {
    background: "#FFF3E4",
    color: "#A45E0B"
  }
}
export const USER_EXAM_STATUS = {
  starting : {
    background: "#F4F5F6",
    color: "#6D6F73",
    text: "In Partenza"
  },
  completed: {
    background: "#F0FFE0",
    color: "#41790A",
    text: "Completato"
  },
  rejected: {
    background: "#FFE0E0",
    color: "#A22020",
    text: "Annullato"
  },
  in_progress: {
    background: "#FFF3E4",
    color: "#A45E0B",
    text: "In corso",
  },
  correction_in_progress: {
    background: "#FFF3E4",
    color: "#A45E0B",
    text: "Correzione in corso"
  },
  review_needed: {
    background: "#ffe4fa",
    color: "#930ba4",
    text: "Revisione necessaria"
  },
  deleted: {
    background: "#FFE0E0",
    color: "#A22020",
    text: "Annullato"
  }
}
export const ADMIN_PERMISSIONS = ['users', 'trainings', 'exams', 'personalizations', 'notifications']